import { useLayer } from '@coursera-web/statsig';

export function useIsFeedEnabled(): boolean {
  const layer = useLayer('consumer-home-feed');
  const showFeed = layer.get('show-feed', false);
  return showFeed;
}
